import { useCallback, useState } from "react";
import {
  getCmsPurchaseDetailRequest,
  listCmsPurchasesRequest,
} from "@services/cmsPurchases/cmsPurchasesApi";

const initialPagination = {
  page: 1,
  limit: 20,
  total: 0,
  totalPages: 1,
};

function useCmsPurchases() {
  const [purchases, setPurchases] = useState([]);
  const [pagination, setPagination] = useState(initialPagination);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const [loading, setLoading] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchPurchases = useCallback(
    async ({ page = 1, limit = 20, search = "", environment = "all" } = {}) => {
      setLoading(true);
      setError("");
      try {
        const response = await listCmsPurchasesRequest({
          page,
          limit,
          search,
          environment,
        });
        setPurchases(response.body.purchases);
        setPagination(response.body.pagination);
      } catch (err) {
        setError(err.message);
        setPurchases([]);
        setPagination(initialPagination);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const fetchPurchaseDetail = useCallback(async (id) => {
    if (!id) return;
    setDetailLoading(true);
    setError("");
    try {
      const response = await getCmsPurchaseDetailRequest(id);
      setSelectedPurchase(response.body);
    } catch (err) {
      setError(err.message);
      setSelectedPurchase(null);
    } finally {
      setDetailLoading(false);
    }
  }, []);

  return {
    purchases,
    pagination,
    selectedPurchase,
    loading,
    detailLoading,
    error,
    fetchPurchases,
    fetchPurchaseDetail,
    clearSelectedPurchase: () => setSelectedPurchase(null),
  };
}

export default useCmsPurchases;
